export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Preautorizzato.vue?vue&type=template&id=2f0fe2a0&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/Preautorizzato.vue?vue&type=template&id=2f0fe2a0&scoped=true&
// module id = 904
// module chunks = 0